import { useState } from "react";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CircularProgress from '@material-ui/core/CircularProgress';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br';

import Categoria from '@base/Categoria/Categoria';
import Text from '@base/Inputs/Text/TextField';
import ButtonPrimary from "@base/Button";

import AjudaService from '@services/AjudaService';

import { isBlankHelperText } from "@helpers/ValidationHelper";

export const ListagemAjuda = ({ ajuda, toast }) => {  
  const [loading, setLoading] = useState(false);

  const [id, ] = useState(ajuda.id);

  const [titulo, setTitulo] = useState(ajuda.titulo);
  const [errorTexto, setErrorTexto] = useState(false);
  const [helperTexto, setHelperTexto] = useState("");

  const [texto, setTexto] = useState(ajuda.texto);
  const [errorTitulo, setErrorTitulo] = useState(false);
  const [helperTitulo, setHelperTitulo] = useState("");

  const isValid = () => {
    if (!titulo || !texto) {
      if (!titulo) {
        setErrorTitulo(true);
        setHelperTitulo(isBlankHelperText());
      }

      if (!texto) {
        setErrorTexto(true);
        setHelperTexto(isBlankHelperText());
      }

      return false;
    }

    return true;
  }

  const handleSave = () => {
    setLoading(true);
    
    if (!isValid()) {
      setLoading(false);
      return 
    }

    AjudaService.editar(id, { titulo: titulo, texto: texto })
      .then(() => toast.current.show("success", "Texto Salvo com Sucesso."))
      .catch(() => toast.current.show("error", "Ocorreu um Problema ao Salvar o Texto."))
      .finally(() => setLoading(false));
  }

  return (
    <Categoria nome={<span style={{ fontWeight: 'bold' }}>{id}</span>} defaultExpanded={false}>
      <Grid container spacing={3} style={{ paddingTop: 2 }}>
        <Grid item sm={12} lg={12}>
          <Text
            required
            label="Titulo do Alerta"
            value={titulo}
            error={errorTitulo}
            onChange={(e) => setTitulo(e.target.value)}
            helperText={helperTitulo}
          />

          <Typography variant="body2" display="inline" style={{ paddingTop: 8, fontSize: 12, color: 'rgba(0, 0, 0, 0.54)' }}>
            Texto do Alerta <sup>*</sup> &nbsp;
          </Typography>

          { errorTexto && <Typography variant="body2" display="inline" style={{ fontSize: 12, color: '#f34539' }}>{helperTexto}</Typography> }

          <CKEditor
            editor={ClassicEditor}
            data={texto}
            onChange={(event, editor) => setTexto(editor.getData())}
            config={{
              licenseKey: 'GPL',
              language: 'pt-br',              
              toolbar: { 
                items: [
                  'undo', 'redo', '|',
                  'heading', '|',                  
                  'bold', 'italic', '|',
                  'link', 'blockQuote',  '|',
                  'bulletedList', 'numberedList', 'outdent', 'indent'
                ],
                shouldNotGroupWhenFull: false,
              },
              link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
                decorators: {
                  toggleDownloadable: {
                    mode: 'manual',
                    label: 'Downloadable',
                    attributes: {
                      download: 'file'
                    }
                  }
                }
              },
              list: {
                properties: {
                  styles: true,
                  startIndex: true,
                  reversed: true
                }
              },
            }}
          />
        </Grid>

        <Grid item sm={12} lg={12} style={{ textAlign: "end" }}>
          <ButtonPrimary
            onClick={handleSave}
            name={`Salvar Texto para ${id}`}
            startIcon={loading ? <CircularProgress size={16} /> : <DoneAllIcon />}
            disabled={loading}
          />
        </Grid>
      </Grid>
    </Categoria>
  );
}

export default ListagemAjuda;
